// Header-Scrollzustand: setzt .is-scrolled auf den sticky Header (#bfw-header),
// sobald die Seite gescrollt ist. _navigation.scss zeichnet damit die graue Unterlinie.
export function initHeaderScroll() {
  const header = document.getElementById('bfw-header');
  if (!header) return;

  const update = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 0);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
}
